const createArrayBouncer = (arr) => (item, allowPush = true) => {
  if (allowPush) {
    arr.push(item);
  }
};

export const get = (name) => {
  if (typeof window === 'undefined') return undefined;

  const matches = document.cookie.match(
    new RegExp(`(?:^|; )${name.replace(/([.$?*|{}()[]\\\/+^])/g, '\\$1')}=([^;]*)`),
  );

  return matches ? decodeURIComponent(matches[1]) : undefined;
};

export const setCookie = ({
  domain,
  maxAge,
  name,
  path = '/',
  sameSite = 'lax',
  secure = true,
  ttl,
  value = '',
}) => {
  if (typeof window !== 'undefined') {
    const _ttl = Number(ttl);
    const _maxAge = Number(maxAge);

    const freshlyBakedCookie = [`${name}=${value}`];

    const cookiePropsBouncer = createArrayBouncer(freshlyBakedCookie);

    cookiePropsBouncer(`domain=${domain}`, Boolean(domain));
    cookiePropsBouncer(`path=${path}`, Boolean(path));
    cookiePropsBouncer(
      `expires=${new Date(new Date().getTime() + _ttl).toUTCString()}`,
      !Number.isNaN(_ttl),
    );
    cookiePropsBouncer(`max-age=${_maxAge}`, !Number.isNaN(_maxAge));
    cookiePropsBouncer('secure', secure);
    cookiePropsBouncer(`samesite=${sameSite}`, Boolean(sameSite));

    document.cookie = freshlyBakedCookie.join(';');
  }
};

export const deleteCookie = (name, props = {}) => {
  setCookie({
    ...props,
    name,
    value: '',
    maxAge: -1,
  });
};
